export const LOCALIZATION_DEFAULT_LOCALE = 'en-US';

export const LOCALIZATION_DEFAULT_NUMBER = {
    decimalSeparator: '.',
    thousandSeparator: ','
};
